<div
  [ngClass]="{
    'order-entry__panel-more__stpagg__container': true,
    'order-entry__panel-more__stpagg__container--checked': data.checkbox.value && !data.locked,
    'order-entry__panel-more__stpagg__container--unchecked': !data.checkbox.value && !data.locked,
    'order-entry__panel-more__stpagg__container--locked': data.locked
  }"
>
  <p-checkbox
    class="order-entry__panel-more__stpagg bfx-checkbox-bold-sm bfx-checkbox-bold-unsized"
    [label]="data.label"
    [binary]="true"
    [disabled]="data.disabled || data.locked"
    [(ngModel)]="data.checkbox.value"
  >
  </p-checkbox>
</div>
